import React from 'react';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { setConsent } from 'features/consent/consentSlice';
import { ConsentState } from 'features/consent/consentTypes';
import { Button } from 'ui/atoms/buttons';
import styled from 'styled-components';

const BannerContainer = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f8f9fa;
  padding: 16px;
  box-shadow: 0 -2px 5px rgba(0,0,0,0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 1000;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 8px;
`;




export const ConsentBanner = () => {
  const dispatch = useAppDispatch();
  const { decided } = useAppSelector(s => s.consent);

  if (decided) return null;


  return (
    <BannerContainer>
      <div>
        We use cookies to enhance your experience. By continuing to visit this site you agree to our use of cookies.
      </div>
      <ButtonGroup>
        <Button onClick={() => dispatch(setConsent({ analytics: false, marketing: false } as ConsentState))}>
          Decline
        </Button>
        <Button $variant="primary" onClick={() => dispatch(setConsent({ analytics: true, marketing: true } as ConsentState))}>
          Accept All
        </Button>
        <Button onClick={() => dispatch(setConsent({ analytics: true, marketing: false } as ConsentState))}>
          Accept Necessary & Analytics
        </Button>
      </ButtonGroup>
    </BannerContainer>
  );
};
